<template>
  <div class="equipments-categorical">
    <b-loading :active="isLoading"></b-loading>
    <div class="columns">
      <div class="column is-full">
        <b-tabs type="is-boxed">
          <b-tab-item :label="$t('categories-view.categories')">
            <div class="columns is-vcentered" style="margin-top: 16px">
              <div class="column">
                <b-button class="button is-primary is-mobile" icon-left="plus-thick"
                          @click="addNewCategoryClicked">
                  {{ $t('common.add') }}
                </b-button>
              </div>
            </div>
            <div class="columns">
              <div class="column is-full">
                <b-table class="templates-table" :data="categories" :striped="true" :hoverable="true"
                         :mobile-cards="true" :scrollable="true">
                  <b-table-column field="" :label="this.$t('categories-view.name')"
                                  v-slot="props">
                    {{ props.row }}
                  </b-table-column>
                  <b-table-column v-slot="props" cellClass="has-text-right">
                    <b-button class="button is-primary is-danger is-small" icon-left="delete" style="margin-left: 8px"
                              @click="deleteCategoryClicked(props.row)">
                      {{ $t('categories-view.delete') }}
                    </b-button>
                  </b-table-column>
                </b-table>
              </div>
            </div>
          </b-tab-item>
          <b-tab-item :label="$t('categories-view.providers')">
            <div class="columns is-vcentered" style="margin-top: 16px">
              <div class="column">
                <b-button class="button is-primary is-mobile" icon-left="plus-thick"
                          @click="addNewProviderClicked">
                  {{ $t('common.add') }}
                </b-button>
              </div>
            </div>
            <div class="columns">
              <div class="column is-full">
                <b-table class="templates-table" :data="providers" :striped="true" :hoverable="true"
                         :mobile-cards="true" :scrollable="true">
                  <b-table-column field="" :label="this.$t('categories-view.name')"
                                  v-slot="props">
                    {{ props.row }}
                  </b-table-column>
                  <b-table-column v-slot="props" cellClass="has-text-right">
                    <b-button class="button is-primary is-danger is-small" icon-left="delete" style="margin-left: 8px"
                              @click="deleteProviderClicked(props.row)">
                      {{ $t('categories-view.delete') }}
                    </b-button>
                  </b-table-column>
                </b-table>
              </div>
            </div>
          </b-tab-item>
        </b-tabs>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "EquipmentsCategorical",
  props: {
    categorical_data: {
      category: [],
      provider: []
    }
  },
  data() {
    return {
      categories: [],
      providers: [],
      isLoading: false
    }
  },
  watch: {
    categorical_data: function () {
      this.categories = this.categorical_data.category
      this.providers = this.categorical_data.provider
    }
  },
  methods: {
    /*
     UI Events
     */
    deleteCategoryClicked: function (category) {
      const confirmBlock = () => {
        const categoriesToUpdate = JSON.parse(JSON.stringify(this.categories));
        for (let i = categoriesToUpdate.length - 1; i >= 0; i--) {
          if (categoriesToUpdate[i] === category) categoriesToUpdate.splice(i, 1);
        }
        const payload = {
          data: categoriesToUpdate,
          collectionName: "equipments",
          dataFieldTitle: "category"
        }
        this.$emit('updateCategoricalData', payload)
      }
      this.$emit('deleteCategoricalData', confirmBlock)
    },
    deleteProviderClicked: function (provider) {
      const confirmBlock = () => {
        const providersToUpdate = JSON.parse(JSON.stringify(this.providers));
        for (let i = providersToUpdate.length - 1; i >= 0; i--) {
          if (providersToUpdate[i] === provider) providersToUpdate.splice(i, 1);
        }
        const payload = {
          data: providersToUpdate,
          collectionName: "equipments",
          dataFieldTitle: "provider"
        }
        this.$emit('updateCategoricalData', payload)
      }
      this.$emit('deleteCategoricalData', confirmBlock)
    },
    addNewCategoryClicked: function () {
      const confirmBlock = (value) => {
        if (value !== '' && !this.categories.includes(value)) {
          const categoriesToUpdate = JSON.parse(JSON.stringify(this.categories));
          categoriesToUpdate.push(value)
          const payload = {
            data: categoriesToUpdate,
            collectionName: "equipments",
            dataFieldTitle: "category"
          }
          this.$emit('updateCategoricalData', payload)
        } else {
          this.showError(this.$t("categories-view.generic-add-element-error"))
        }
      }
      this.$emit('addCategoricalData', confirmBlock)
    },
    addNewProviderClicked: function () {
      const confirmBlock = (value) => {
        if (value !== '' && !this.providers.includes(value)) {
          const providersToUpdate = JSON.parse(JSON.stringify(this.providers));
          providersToUpdate.push(value)
          const payload = {
            data: providersToUpdate,
            collectionName: "equipments",
            dataFieldTitle: "provider"
          }
          this.$emit('updateCategoricalData', payload)
        } else {
          this.showError(this.$t("categories-view.generic-add-element-error"))
        }
      }
      this.$emit('addCategoricalData', confirmBlock)
    }
  },
  mounted() {
  }
};
</script>

<style scoped>
.equipments-categorical {
  margin-top: 16px;
}
</style>
